<template>
  <LoyaltyArea
    heading="Members Only"
    :images="{
      smallMedia:
        'https://cdn.shopify.com/s/files/1/0942/9062/files/Artboard_1-2_1.jpg?v=1652607000',
      mediumMedia:
        'https://cdn.shopify.com/s/files/1/0942/9062/files/Artboard_1-2_1.jpg?v=1652607000',
      largeMedia:
        'https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty_ba7ec7e1-e69e-4a7d-a750-b0ef123d768e.jpg',
    }"
    :links="[
      { url: 'ratandboa.com', text: 'Sign Up to Start Earning' },
      { url: 'ratandboa.com', text: 'Login to Your Account' },
    ]"
  />
  <LoyaltySteps
    :items="[
      {
        heading: 'JOIN',
        text: 'Create an account and we’ll give you 400 style points to spend.',
        images: {
          smallMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-step-1.jpg',
          mediumMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-step-1.jpg',
          largeMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-step-1.jpg',
        },
      },
      {
        heading: 'VIP',
        text: 'Early access to sales and collection launches.',
        images: {
          smallMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-step-2.jpg',
          mediumMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-step-2.jpg',
          largeMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-step-2.jpg',
        },
      },
      {
        heading: 'SPEND',
        text: 'Keep track of your points by signing into your account and put them towards the next piece you buy.',
        images: {
          smallMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-step-3.jpg',
          mediumMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-step-3.jpg',
          largeMedia:
            'https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-step-3.jpg',
        },
      },
    ]"
  />
  <LoyaltyFeature
    :image-one="{
      smallMedia:
        'https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-feature-1.jpg',
      mediumMedia:
        'https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-feature-1.jpg',
      largeMedia:
        'https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-feature-1.jpg',
    }"
    :image-two="{
      smallMedia:
        'https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-gift.jpg',
      mediumMedia:
        'https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-gift.jpg',
      largeMedia:
        'https://cdn.shopify.com/s/files/1/0942/9062/files/loyalty-gift.jpg',
    }"
    :text="`Sign up now and not only will you get priority access to our flash sales, the chance to shop new collections ahead of the crowds and to vote on possible new styles and silhouettes, we'll also give you ${bonus} credit to say thank you. Plus, for every £1 you spend, you'll earn points that you can put towards more of the pieces that catch your eye.`"
  />
  <LoyaltyTiers />
  <Questions
    :questions="[
      {
        heading: 'What is Members Only?',
        text: 'Members Only is Rat & Boa’s bespoke loyalty programme. Sign up and you’ll earn style points on qualifying purchases and other interactions with us. The more style points you have, the higher your loyalty tier and the more benefits you’ll have access to.',
      },
      {
        heading: 'How do I join Members Only?',
        text: 'You can sign up and create an account here.',
      },
      {
        heading: 'How can I view my style points and tier?',
        text: 'Your point balance and current tier level is shown in the top bar in your account page.',
      },
      {
        heading: 'What can I do with my style points?',
        text: 'Style points can be redeemed at checkout, or you can convert style points into vouchers for credit towards your next order. Head to your account page anytime to see the benefits and rewards that are available to you.',
      },
      {
        heading: 'How is my tier calculated?',
        text: 'Your Members Only tier is based on net annual spend. At the point of sign up, if you have spent £0-£189 in the previous year, you will start as a White tier loyalty member, if you have spent £190-£379 you will start as a Grey tier loyalty member and, if you have spent over £380, you will start as a Black tier loyalty member. As a member, when your annual spend reaches the next threshold, you will automatically tier up and have access to a host of new rewards and benefits. Please note that returned orders do not count towards your annual total.',
      },
      {
        heading: 'What are ‘pending’ style points?',
        text: 'These are points that need to be approved by our customer service team before they can be added to your balance.',
      },
      {
        heading: 'What are ‘cancelled’ style points?',
        text: 'These points will not be added to your balance. For example, if you have returned a piece, the points will change from pending to cancelled.',
      },
      {
        heading:
          'What happens if a friend that I refer cancels or returns their order?',
        text: 'The pending points that you earned from their order will be cancelled and will not be added to your balance.',
      },
      {
        heading: 'Why did my account balance go down?',
        text: 'This is likely to be because you, or someone that you referred, cancelled or returned an order.',
      },
      {
        heading: 'How can I leave Members Only?',
        text: 'If you no longer wish to be part of our Loyalty Programme, please contact us and we will cancel your account. You will lose any points you have collected.',
      },
      {
        heading: 'Can I join again?',
        text: 'Yes, of course. Simply contact us and we will reopen your account. Unfortunately, we are unable to save points on cancelled accounts, so your points total will begin again from zero.',
      },
      {
        heading: 'Can I use my style points on sale items?',
        text: 'Unfortunately style points and loyalty credit are not valid on sale items. You will earn points on any sale items that you buy.',
      },
    ]"
  />
  <Newsletter />
</template>

<script>
import { mapGetters } from "vuex";

import LoyaltyArea from "@/components/loyalty/LoyaltyArea.vue";
import LoyaltyFeature from "@/components/loyalty/LoyaltyFeature.vue";
import LoyaltySteps from "@/components/loyalty/LoyaltySteps.vue";
import LoyaltyTiers from "@/components/loyalty/LoyaltyTiers.vue";
import Questions from "@/components/Questions.vue";
import { signUpBonus } from "@/config";
import Newsletter from "@/components/Newsletter.vue";

export default {
  name: "Loyalty",
  components: {
    LoyaltyArea,
    LoyaltySteps,
    LoyaltyFeature,
    LoyaltyTiers,
    Questions,
    Newsletter,
  },
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    bonus() {
      if (!this.currencyCode) {
        return null;
      }
      const amount = signUpBonus[this.currencyCode];
      return this.$filters.toCurrency(amount, this.currencyCode, 0);
    },
  },
};
</script>
